var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0016 25.2001C15.6416 25.2001 13.5416 24.5301 11.7016 23.1901C9.86156 21.8501 8.56156 20.1201 7.80156 18.0001H3.60156V15.6001H7.26156C7.20156 15.1201 7.17656 14.6751 7.18656 14.2651C7.19656 13.8551 7.22156 13.5001 7.26156 13.2001H3.60156V10.8001H7.80156C8.56156 8.6801 9.86156 6.9501 11.7016 5.6101C13.5416 4.2701 15.6416 3.6001 18.0016 3.6001C19.3816 3.6001 20.6866 3.8451 21.9166 4.3351C23.1466 4.8251 24.2416 5.5001 25.2016 6.3601L23.4916 8.0401C22.7516 7.4001 21.9166 6.9001 20.9866 6.5401C20.0566 6.1801 19.0616 6.0001 18.0016 6.0001C16.3016 6.0001 14.7816 6.4451 13.4416 7.3351C12.1016 8.2251 11.0916 9.3801 10.4116 10.8001H18.0016V13.2001H9.69156C9.61156 13.7401 9.58156 14.2151 9.60156 14.6251C9.62156 15.0351 9.65156 15.3601 9.69156 15.6001H18.0016V18.0001H10.4116C11.0916 19.4201 12.1016 20.5751 13.4416 21.4651C14.7816 22.3551 16.3016 22.8001 18.0016 22.8001C19.0616 22.8001 20.0566 22.6201 20.9866 22.2601C21.9166 21.9001 22.7516 21.4001 23.4916 20.7601L25.2016 22.4401C24.2416 23.3001 23.1466 23.9751 21.9166 24.4651C20.6866 24.9551 19.3816 25.2001 18.0016 25.2001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyIcon);
export default __webpack_public_path__ + "static/media/CurrencyIcon.66f0f177f322f199dc6bf077e15942eb.svg";
export { ForwardRef as ReactComponent };